import client from '../client';
import type { ApiResponse } from '../../types/api';

export interface LiveVisitor {
  sessionId: string;
  visitorId?: string;
  page: string;
  url?: string;
  event?: string;
  timestamp?: string;
  geo?: { lat: number; lon?: number; lng?: number; country?: string; city?: string };
  customerId?: string;
  pageCount?: number;
  duration?: number;
}

export interface LiveEvent {
  type: 'event';
  event: string;
  timestamp: string;
  geo?: { lat: number; lon?: number; lng?: number; country?: string; city?: string };
  page?: string;
  productId?: string;
  title?: string;
  visitorId?: string;
  sessionId?: string;
  customerId?: string;
}

export const liveVisitorsApi = {
  getActive: async (storeId: string) => {
    const res = await client.get<ApiResponse<{ activeCount: number; visitors: LiveVisitor[] }>>(
      `/dashboard/${storeId}/live/active`,
    );
    return res.data.data!;
  },

  getRecent: async (storeId: string) => {
    const res = await client.get<ApiResponse<{ visitors: LiveVisitor[]; activeCount: number }>>(
      `/dashboard/${storeId}/live/recent`,
    );
    return res.data.data!;
  },

  /**
   * Returns the SSE stream URL. The component should use EventSource directly.
   */
  getStreamUrl: (storeId: string) => {
    const base = client.defaults.baseURL ?? '/api/v1';
    return `${base}/dashboard/${storeId}/live/stream`;
  },
};
